import { Divider, Spin } from "antd";
import { observer } from "mobx-react";
import { useState } from "react";
import { useEffect } from "react";
import { __ } from "../../../../utils";
import { AccountLicenseActivationsTable } from ".";
const AccountLicenseExpand = observer(_ref => {
  let {
    record
  } = _ref;
  const {
    activations
  } = record;
  const [isLoaded, setIsLoaded] = useState(false);
  useEffect(() => {
    record.fetchActivations().then(() => setIsLoaded(true));
  }, [record]);
  return /*#__PURE__*/React.createElement(Spin, {
    spinning: !isLoaded
  }, isLoaded && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Divider, {
    style: {
      marginTop: 0
    },
    orientation: "left"
  }, __("Active license activations")), /*#__PURE__*/React.createElement(AccountLicenseActivationsTable, {
    records: Array.from(activations.values())
  })));
});
export { AccountLicenseExpand };